import { createContext } from 'react';

import { MinMax } from '../../core/types/min-max.js';

export const HoneycombExtentConfig = createContext<Partial<MinMax> | undefined>(
  undefined,
);
